import React, {useRef, useState, createRef, useEffect} from 'react';

const RoadObjectEditor = props => {

    const inputRef = useRef([...Array(4).map( e => createRef())]);
    const [inputValues, setInputValues] = useState(['', '', '', '']);
    const [increment, setIncrement] = useState(1);

    useEffect(() => {
        const newEditedRoadObject = {
            class: inputValues[0],
            xOffset: inputValues[1],
            yOffset: inputValues[2],
            zOffset: inputValues[3]
        }
        props.setEditedRoadObject(newEditedRoadObject);
    }, [inputValues, props.setEditedRoadObject])

    const onInputChange = (e,i) => {
        const newInputValues = [...inputValues];
        newInputValues[i] = e.target.value;


        props.roadItems.forEach((e) => {
            // populate form inputs with JSON values when selecting new road item
            // i === 0 is making sure we only populate these inputs when changing the class selector
           if (e.class === newInputValues[0] && i === 0) {
               newInputValues[1] = e.xOffset;
               newInputValues[2] = e.yOffset;
               newInputValues[3] = e.zOffset;
           }
        })

        setInputValues(newInputValues);
    }

    const onObjectSelect= object => {
        const newInputValues = [...inputValues];
        newInputValues[0] = object.class;

        setInputValues(newInputValues);
        newInputValues[1] = object.xOffset;
        newInputValues[2] = object.yOffset;
        newInputValues[3] = object.zOffset;
    }

    const onMouseEnterObject = object => {
        props.setObjectHighlight(object.class);
    }

    const onMouseLeaveObject = () => {
        props.setObjectHighlight(null);
    }
    
    const handleKeyDown = e => {
        // input increments can be changed with the ZXCVB keys
        if (e.key === 'z') {
            setIncrement(0.1);
        }
        if (e.key === 'x') {
            setIncrement(1);
        }
        if (e.key === 'c') {
            setIncrement(10);
        }
        if (e.key === 'v') {
            setIncrement(100);
        }
        if (e.key === 'b') {
            setIncrement(1000);
        }
    }

    return (
        <div className={`RoadObjectEditor`} onKeyDown={handleKeyDown}>
            <div className={`inputs`}>
                {
                    [...new Array(4)].map((e,i) => {
                        return <input key={`input-${i}`} ref={inputRef.current[i]} value={inputValues[i]} onChange={event => {onInputChange(event, i)}} type={`${i === 0 ? 'text' : 'number'}`} step={increment} />
                    })
                }
            </div>
            <div className={`increment`}>Increment: {increment}</div>
            <div className={`object-json`}>{`{"xOffset": "${inputValues[1]}",
              "yOffset": "${inputValues[2]}",
              "zOffset": "${inputValues[3]}",
              "class": "${inputValues[0]}"},`}</div>
            <div className={`object-selector`}>{
                [props.roadItems.map((e,i) => {
                    return <div className={`object object-${i}`} onMouseEnter={() => onMouseEnterObject(e)} onMouseLeave={onMouseLeaveObject} onClick={() => onObjectSelect(e)}>{e.class}</div>
                })]
            }</div>
        </div>
    )
}

export default RoadObjectEditor